<template>
    <h3>Version 1.0.0</h3>
    <router-link to="/">Go Back</router-link>
</template>